<template>
  <b-row>
    <!-- LISTA DE PRESENÇA -->
    <b-modal
      ref="modalAssinar"
      centered
      title="Lista de presença"
      ok-only
      ok-title="Confirmar"
      @ok="onAssinar"
    >
      <b-card-text>
        <b-row>
          <b-col>
            <p>
              Selecione as unidades que você representa, assine manualmente na
              área pontilhada e pressione o botão
              <strong>"Assinar"</strong>.
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-list-group class="mb-1">
              <b-list-group-item
                v-for="(item, index) in listaPresenca"
                :key="index"
                class="d-flex justify-content-between align-items-center"
              >
                <b-form-checkbox
                  v-model="item.presente"
                  :disabled="item.participante && item.participante.id > 0"
                  class="ml-0"
                >{{ item.unidade.nome }}
                  {{ item.unidade.bloco }}</b-form-checkbox>
                <span
                  v-if="item.participante && item.participante.dataAssinatura"
                >{{
                  new Date(
                    item.participante.dataAssinatura,
                  ).toLocaleDateString('pt-BR', {})
                }}</span>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
        <b-row>
          <template>
            <assinatura-pad :anexo="assinatura" />
          </template>
        </b-row>
      </b-card-text>
    </b-modal>

    <b-alert
      :show="assembleia.situacao === 'ENCERRADA'"
      align="center"
      variant="primary"
      class="w-100 p-1"
    >
      <h2>Encerrada</h2>
    </b-alert>

    <b-col
      cols="12"
      class="mb-1"
    ><h3>{{ assembleia.titulo }}</h3></b-col>

    <b-col
      cols="12"
      align="right"
      class="mb-2"
    >
      <template slot="actions" />
      <b-button
        v-if="podeVotar"
        variant="outline-primary"
        size="sm"
        @click="onClickAtualizar()"
      ><feather-icon icon="RefreshCwIcon" />Atualizar</b-button>
      &nbsp;
      <b-button
        v-if="exibirPautas && podeVotar"
        variant="outline-primary"
        size="sm"
        @click="$refs['modalAssinar'].show()"
      >
        <feather-icon icon="EditIcon" />Assinar</b-button>
    </b-col>
    <b-col cols="12">
      <b-tabs
        pills
        class="w-100"
      >
        <b-tab active>
          <template v-slot:title>
            Pauta
            <b-badge
              class="ml-1"
              pill
            >
              {{ assembleia.itensPauta.length }}
            </b-badge>
          </template>
          <b-row>
            <b-col
              v-if="
                !assembleia ||
                  !assembleia.itensPauta ||
                  assembleia.itensPauta.length == 0
              "
            >
              Nenhum item foi adicionado a esta pauta
            </b-col>
            <b-col
              v-for="(item, index) in assembleia.itensPauta"
              v-else
              :key="index"
              cols="12"
              md="6"
              lg="6"
              class="d-flex"
            >
              <b-card
                :title="item.descricao"
                class="w-100"
              >
                <b-tabs>
                  <b-tab title="Detalhes">
                    <b-badge
                      :variant="item.permiteVoto ? 'primary' : 'secondary'"
                    >{{
                      item.permiteVoto ? ' com votação' : 'sem votação'
                    }}</b-badge>
                    <b-card-text v-html="item.detalhamento" />
                  </b-tab>
                  <b-tab
                    v-if="item.permiteVoto"
                    active
                  >
                    <template v-slot:title>
                      Votação
                      <b-badge
                        class="ml-1"
                        pill
                      >
                        {{ Object.keys(listaPorParticipante).length }}
                      </b-badge>
                    </template>
                    <b-card-text>
                      <votacao-item
                        :item-pauta="item"
                        :pode-votar="podeVotar"
                        :assembleia="assembleia"
                        :lista-presenca="listaPresenca"
                        :lista-por-participante="listaPorParticipante"
                        @votado="itemVotado"
                      />
                    </b-card-text>
                  </b-tab>
                  <b-tab
                    title="Comentários"
                    lazy
                  >
                    <comentarios-assembleia
                      :assembleia="assembleia"
                      :pode-votar="podeVotar"
                      :item-pauta="item"
                    />
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Edital">
          <b-card>
            <b-card-text v-html="assembleia.pauta" />
          </b-card>
        </b-tab>
        <b-tab
          v-if="exibirPautas"
          title="Comentários"
        >
          <comentarios-assembleia
            :assembleia="assembleia"
            :item-pauta="null"
            :pode-votar="podeVotar"
          />
        </b-tab>
        <b-tab
          v-if="exibirPautas && verResultado"
          title="Resultados"
        >
          <resultados
            :itens-pauta="assembleia.itensPauta"
            :assembleia="assembleia"
          />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import {
  BModal,
  BFormCheckbox,
  BListGroup,
  BListGroupItem,
  BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import AssembleiaAPI from '@/api/assembleia'
import UploadAPI from '@/api/upload'
import MinhaContaAPI from '@/api/minhaconta'

import dataURItoBlob from '@/libs/img'

import AssinaturaPad from '../../commons/AssinaturaPad.vue'
import Comentarios from './Comentarios.vue'
import Resultados from './Resultados.vue'
import VotacaoItem from './VotacaoItem.vue'

export default {
  name: 'ItensPautaAssembleia',
  components: {
    'comentarios-assembleia': Comentarios,
    'assinatura-pad': AssinaturaPad,
    BModal,
    BFormCheckbox,
    BListGroup,
    BListGroupItem,
    BBadge,
    VotacaoItem,
    Resultados,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      assembleia: {
        id: null,
        itensPauta: [],
      },
      exibirPautas: false,
      selectedVoto: [],
      listaPresenca: [],
      listaPorParticipante: {},
      resultados: [],
      assinaturaBase64: null,
      podeVotar: false,
    }
  },
  computed: {
    verResultado() {
      return (
        this.assembleia.situacao === 'ENCERRADA' || !this.assembleia.votoOculto
      )
    },
    assinatura() {
      return this.$store.getters['minhaconta/getAssinatura']()
    },
  },
  async created() {
    // carrega store com minhas empresas, unidades, interesses, anexos
    this.$store.dispatch('minhaconta/init').then(async () => {
      this.load()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.modalAssinar.hide()
    this.$nextTick().then(() => next())
  },
  methods: {
    async load() {
      // obtem da url o id da assembleia
      if (this.$route.params.id) {
        this.assembleia.id = this.$route.params.id
      }
      try {
        this.$loading.show()
        // recupera dados da assembleia
        const { data: assembleia } = await AssembleiaAPI.getAssembleia(
          this.assembleia.id,
        )
        this.assembleia = Object.assign(this.assembleia, { ...assembleia })

        // verifica se pode votar
        const agora = moment()
        const dataInicial = moment(this.assembleia.dataHoraInicio)
        const dataFinal = moment(this.assembleia.dataHoraEncerramento)

        this.podeVotar = agora.isBetween(dataInicial, dataFinal)
          && this.assembleia.situacao === 'INICIADA'

        // recupera os itens da pauta
        const {
          data: { content: itensPauta },
        } = await AssembleiaAPI.listItemPauta(this.assembleia.id)
        this.$set(this.assembleia, 'itensPauta', itensPauta)
        // recupera interesses da conta
        const { interesses } = this.$store.state.minhaconta
        if (interesses.length === 0) {
          this.showError('Nenhuma unidade vinculada ao seu cadastro.')
          return
        }
        // recupera os participantes, ou seja, interessados que assinara lista de presença
        const paramsParticipante = new URLSearchParams()
        interesses.map(e => paramsParticipante.append('interessadoId', e.id))
        const {
          data: { content: participantes },
        } = await AssembleiaAPI.listParticipante(
          assembleia.id,
          paramsParticipante,
        )
        // transforma array de participantes para map indexado pela interessado
        const participatesPorInteresse = Object.assign(
          {},
          ...participantes.map(participante => ({
            [participante.interessadoId]: participante,
          })),
        )
        // transforma array de interesses para map indexado pela unidade
        const interessesPorUnidade = Object.assign(
          {},
          ...interesses.map(interesse => ({
            [interesse.unidadeId]: interesse,
          })),
        )
        // verifica se há vínculo com alguma unidade a mostra uma mensagem caso não haja
        // monta a lista de presença
        this.$store.state.minhaconta.unidades.forEach((unidade, index) => {
          const interessado = interessesPorUnidade[unidade.id]
          const participante = participatesPorInteresse[interessado.id]
          const presente = participante && participante.id !== 'undefined'
          const presenca = {
            interessado,
            unidade,
            participante,
            presente,
          }
          this.$set(this.listaPresenca, index, presenca)
        })
        // filtra apenas os participantes que assinaram a lista de presença
        const presentes = this.listaPresenca.filter(
          presenca => presenca.presente && presenca.participante.id,
        )
        // verifica se há interessados que ainda não assinaram
        if (this.assembleia.situacao !== 'ENCERRADA' && presentes.length < 1) {
          this.$refs.modalAssinar.show()
        }
        // recupera as opções de voto para cada item de pauta
        await this.assembleia.itensPauta.forEach(async itemPauta => {
          // recupera opcoes de voto pra cada item da pauta
          const {
            data: { content: opcoesVoto },
          } = await AssembleiaAPI.listOptionsVote(assembleia.id, itemPauta.id)
          this.$set(itemPauta, 'opcoesVoto', opcoesVoto)
          // monta os votos para cada participantes
          const {
            data: { content: itenVotados },
          } = await AssembleiaAPI.listVoto(
            this.assembleia.id,
            itemPauta.id,
            paramsParticipante,
          )
          // transforma array de interesses para map indexado pela unidade
          const votosPorParticipante = Object.assign(
            {},
            ...itenVotados.map(voto => ({
              [voto.participanteId]: voto,
            })),
          )
          const votos = []
          presentes.forEach(item => {
            const voto = votosPorParticipante[item.participante.id]
            votos.push({
              id: voto ? voto.id : null,
              participanteId: item.participante.id,
              tipo: null,
              opcaoVotoId: voto ? voto.opcaoVotoId : null,
            })
          })
          this.$set(itemPauta, 'votos', votos)
        })
        presentes.forEach(presenca => this.$set(
          this.listaPorParticipante,
          `${presenca.participante.id}`,
          presenca,
        ))
        // renderiza a tab com os itens de pauta
        this.exibirPautas = true
      } finally {
        this.$loading.hide()
      }
    },
    onAssinado(assinaturaBase64) {
      this.assinaturaBase64 = assinaturaBase64
    },
    async onAssinar() {
      if (this.assinaturaBase64) {
        const blob = dataURItoBlob(this.assinaturaBase64)
        const fd = new FormData(document.forms[0])
        fd.append('arquivos', blob, 'assinatura.png')
        const upload = await UploadAPI.upload(fd)
        const anexos = upload.data
        if (anexos.length === 1) {
          try {
            if (this.assinatura && this.assinatura.id) {
              await MinhaContaAPI.deleteAnexo(this.assinatura.id)
            }
            const anexo = anexos[0]
            anexo.tipoAnexo = 'ASSINATURA'
            await MinhaContaAPI.createAnexo(anexo)
            this.$store.dispatch('minhaconta/fetchAnexos')
          } catch (err) {
            this.showError(err)
          }
        }
      }
      // filtra participantes presentes
      const presencas = this.listaPresenca.filter(
        p => p.presente && !p.participante,
      )
      presencas.forEach(async presenca => {
        try {
          // cria a presença do participante
          const { data: participante } = await AssembleiaAPI.createParticipante(
            this.assembleia.id,
            {
              interessadoId: presenca.interessado.id,
            },
          )
          // procura o índice da assinatura na lista de presença
          const index = this.listaPresenca.findIndex(
            p => p.interessado.id === participante.interessadoId,
          )
          // atualiza lista de presença com a participante que assinou
          this.listaPresenca[index] = {
            ...this.listaPresenca[index],
            participante,
          }
          // atualiza o map da lista de presença
          this.$set(this.listaPorParticipante, `${participante.id}`, {
            ...presenca,
            participante,
            presente: true,
          })
          this.showSuccess(
            `Assinatura ${
              this.listaPorParticipante[participante.id].unidade.nome
            } realizada com sucesso`,
          )
        } catch (err) {
          this.showError(err)
        } finally {
          this.load()
        }
      })
    },
    /**
     * Evento que é chamado quando um item de pauta é votado.
     */
    itemVotado({ itemPauta, voto }) {
      const itemRecuperado = this.assembleia.itensPauta.find(
        item => item.id === itemPauta.id,
      )
      if (itemRecuperado) {
        const index = itemRecuperado.votos.findIndex(
          item => item.opcaoVotoId === voto.opcaoVotoId
            && item.participanteId === voto.participanteId,
        )
        this.$set(itemRecuperado.votos, index, voto)

        this.$toast.success('Voto realizado com sucesso')
      }
    },
    onClickAtualizar() {
      this.load()
    },
    showError(err) {
      this.$toast.error(err.response ? err.response.data.error : err)
    },
    showSuccess(msg) {
      this.$toast.success(msg)
    },
  },
}
</script>

<style lang="scss"></style>
